document.addEventListener("DOMContentLoaded", function () {
  // Tab functionality
  const tabBtns = document.querySelectorAll(".cg-products__tab-btn");
  const tabContents = document.querySelectorAll(".cg-products__tab-content");
  
  // B2B (SparkLayer): when the Memory Foam tab is hidden, auto-activate the Hybrid tab
  const mfTabBtn = document.querySelector('.cg-products__tab-btn[data-tab="memory-foam"]');
  const hybridTabBtn = document.querySelector('.cg-products__tab-btn[data-tab="hybrid"]');
  function activateHybridIfB2B() {
    if (!mfTabBtn || !hybridTabBtn) return;
    if (getComputedStyle(mfTabBtn).display !== 'none') return;
    const hybridContent = document.getElementById('hybrid');
    const needsBtn = !hybridTabBtn.classList.contains('active');
    const needsContent = hybridContent && !hybridContent.classList.contains('active');
    if (needsBtn || needsContent) {
      tabBtns.forEach((tb) => tb.classList.remove('active'));
      tabContents.forEach((tc) => tc.classList.remove('active'));
      hybridTabBtn.classList.add('active');
      if (hybridContent) hybridContent.classList.add('active');
    }
  }
  activateHybridIfB2B();
  if (window.ResizeObserver && mfTabBtn) {
    new ResizeObserver(activateHybridIfB2B).observe(mfTabBtn);
  }
  
  tabBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      // Remove active class from all tabs
      tabBtns.forEach((tb) => tb.classList.remove("active"));
      tabContents.forEach((tc) => tc.classList.remove("active"));
      
      // Add active class to clicked tab
      btn.classList.add("active");
      document.getElementById(btn.dataset.tab).classList.add("active");
    });
  });
  
  // Add subtle hover effect to product cards
  const productCards = document.querySelectorAll(".cg-product-card");
  productCards.forEach((card) => {
    card.addEventListener("mouseenter", () => {
      productCards.forEach((c) => {
        if (c !== card) {
          c.style.transform = "scale(0.98)";
        }
      });
    });
    
    card.addEventListener("mouseleave", () => {
      productCards.forEach((c) => {
        c.style.opacity = "1";
        c.style.transform = "";
      });
    });
  });
});
